@if(showLoader){
<div class="main-loader" id="main-loader" @fadeIn>
  <fa-icon [icon]="['fal','circle-notch']" animation="spin" class="font-30"></fa-icon>

</div>
}
@if (!hideSidebarNavbar) {
<div style="position: relative;">
  <app-header [isSidebarOpen]="isSidebarOpen"></app-header>
</div>
<app-sidebar (openSidebar)="openSidebar($event)"></app-sidebar>
}
<div style="position: absolute;width: 100%;">
  <ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
</div>

<section [class.sidebar]="!hideSidebarNavbar && !isSidebarOpen"
  [class.sidebar-open]="!hideSidebarNavbar && isSidebarOpen"
  [class.animation]="!hideSidebarNavbar && isSidebarOpen && isInited" 
  [class.home]="changeSectionHeight"
  class="section">
  
  <div>
    <router-outlet></router-outlet>
  </div>

  <div class="footer" [ngClass]="{'hide': hideMobileFooter}">
    <div class="footer-container">
      <div class="copyright">
        {{ 'common-page.footer.copyright'| translate }}
      </div>
      <div class="footer-container-links">
        <a class="footer-link m-r-80" id="common-page.footer.legal-warning"
          (click)="goToLink('https://www.juaneda.es/legal')">{{'common-page.footer.legal-warnings' | translate}}</a>

        <a class="footer-link m-r-80" id="common-page.footer.privacy-policies"
          (click)="goToLink('https://www.juaneda.es/privacy')">{{'common-page.footer.privacy-policies' | translate}}</a>

        <a class="footer-link" id="common-page.footer.cookies-policies" (click)="openCookies()">
          {{'common-page.footer.cookies-policies' | translate}}</a>

      </div>


    </div>

    <!-- MOBILE CONFIGURATIONS FLOAT BUTTON -->
    @if (showFooterFloatButton) {
    <div class="footer-mobile-configurations" hideLarge>
      <div class="footer-mobile-configurations-wrapper" (click)="openMobileStatisticsConfigurations()">
        <fa-icon [icon]="['fal', 'gear']" class="font-16"></fa-icon>
      </div>
    </div>

    }

  </div>

</section>

